// extracted by mini-css-extract-plugin
export default {"wallet_login_wrapper":"wallet_wallet_login_wrapper__1JqYT","divider":"wallet_divider__yVbpP","signup":"wallet_signup__30O79","loginbtn":"wallet_loginbtn__1zVGr"};